import { css } from "styled-components";
import WebFont from "webfontloader";
import * as React from "react";

import { ThemeType } from "src/library/utils";

const MochaMatteriFontStyle = css`
  @font-face {
    font-family: "Mocha Mattari";
    src: url("/assets/fonts/Mocha-Mattari.ttf") format("truetype");
    font-weight: normal;
    font-style: normal;
  }
`;

const CalibriStyle = css`
  ${({ theme }) => css`
    @font-face {
      font-family: "Calibri";
      src: url("/assets/fonts/Calibri/Calibri-Regular.ttf") format("truetype");
      font-weight: normal;
      font-style: normal;
    }

    @font-face {
      font-family: "Calibri";
      src: url("/assets/fonts/Calibri/Calibri-Bold.ttf") format("truetype");
      font-weight: ${theme.fonts.weights.bold};
      font-style: normal;
    }
  `}
`;

const BryantProFontStyle = css`
  ${({ theme }) => css`
    @font-face {
      font-family: "Bryant Pro";
      src: url("/assets/fonts/BryantPro/bryantpro-regularalt-webfont.woff2") format("woff");
      font-weight: normal;
      font-style: normal;
    }

    @font-face {
      font-family: "Bryant Pro";
      src: url("/assets/fonts/BryantPro/bryantpro-bold-webfont.woff2") format("woff");
      font-weight: ${theme.fonts.weights.bold};
      font-style: normal;
    }
  `}
`;

const FuturaLTFontStyle = css`
  ${({ theme }) => css`
    @font-face {
      font-family: "Futura LT";
      src: url("/assets/fonts/FuturaLT/FuturaLT.ttf") format("truetype");
      font-weight: normal;
      font-style: normal;
    }

    @font-face {
      font-family: "Futura LT";
      src: url("/assets/fonts/FuturaLT/FuturaLT.ttf") format("truetype");
      font-weight: ${theme.fonts.weights.bold};
      font-style: normal;
    }
  `}
`;

const NeoHansStyle = css`
  ${({ theme }) => css`
    @font-face {
      font-family: "Neo Hans";
      src: url("/assets/fonts/NeoHans/NeoHans-Regular.ttf") format("truetype");
      font-weight: normal;
      font-style: normal;
    }

    @font-face {
      font-family: "Neo Hans";
      src: url("/assets/fonts/NeoHans/NeoHans-Bold.ttf") format("truetype");
      font-weight: ${theme.fonts.weights.bold};
      font-style: normal;
    }
  `}
`;

const PieplarStyle = css`
  ${({ theme }) => css`
    @font-face {
      font-family: "Pieplar";
      src: url("/assets/fonts/Pieplar.otf") format("opentype");
      font-weight: normal;
      font-style: normal;
    }

    @font-face {
      font-family: "Pieplar";
      src: url("/assets/fonts/Pieplar.otf") format("opentype");
      font-weight: ${theme.fonts.weights.bold};
      font-style: normal;
    }
  `}
`;

const BrandonGrotesqueStyle = css`
  ${({ theme }) => css`
    @font-face {
      font-family: "Brandon Grotesque";
      src: url("/assets/fonts/BrandonGrotesque/Brandon_reg.otf") format("truetype");
      font-weight: normal;
      font-style: normal;
    }

    @font-face {
      font-family: "Brandon Grotesque";
      src: url("/assets/fonts/BrandonGrotesque/Brandon_bld.otf") format("truetype");
      font-weight: ${theme.fonts.weights.bold};
      font-style: normal;
    }
  `}
`;

const ClaredonStyle = css`
  @font-face {
    font-family: "Claredon";
    src: url("/assets/fonts/Claredon/ClarendonLTStd-Light.otf") format("truetype");
    font-weight: normal;
    font-style: normal;
  }
`;

const MicrobrewSoftFourStyle = css`
  @font-face {
    font-family: "Microbrew Soft Four";
    src: url("/assets/fonts/MicrobrewSoftFour/MicrobrewSoftFour.otf") format("truetype");
    font-weight: normal;
    font-style: normal;
  }
`;

const HumbleCraftman = css`
  @font-face {
    font-family: "HumbleCraftman";
    src: url("/assets/fonts/HumbleCraftman/HumbleCraftman_Regular.otf") format("truetype");
    font-weight: normal;
    font-style: normal;
  }
`;

const Poppins = css`
  ${({ theme }) => css`
    @font-face {
      font-family: "Poppins";
      src: url("/assets/fonts/Poppins/Poppins-Regular.ttf") format("truetype");
      font-weight: normal;
      font-style: normal;
    }

    @font-face {
      font-family: "Poppins";
      src: url("/assets/fonts/Poppins/Poppins-Bold.ttf") format("truetype");
      font-weight: ${theme.fonts.weights.bold};
      font-style: normal;
    }
  `}
`;

const customFonts = [
  "Futura LT",
  "Mocha Mattari",
  "Bryant Pro",
  "Neo Hans",
  "Pieplar",
  "Calibri",
  "Brandon Grotesque",
  "Claredon",
  "Microbrew Soft Four",
  "HumbleCraftman",
  "Poppins"
];

const useGoogleFontStyle = (theme?: ThemeType): void => {
  React.useEffect(() => {
    if (theme) {
      if (theme.fonts.family.body) {
        if (!customFonts.includes(theme.fonts.family.body)) {
          WebFont.load({ google: { families: [ `${theme?.fonts.family.body}:300,400` ] } });
        }
      }

      if (theme.fonts.family.heading && theme.fonts.family.heading !== theme.fonts.family.body) {
        if (!customFonts.includes(theme.fonts.family.heading)) {
          WebFont.load({ google: { families: [ `${theme?.fonts.family.heading}:300,400` ] } });
        }
      }
    }
  }, [ theme ]);
};

export {
  MochaMatteriFontStyle,
  useGoogleFontStyle,
  BryantProFontStyle,
  FuturaLTFontStyle,
  NeoHansStyle,
  PieplarStyle,
  CalibriStyle,
  BrandonGrotesqueStyle,
  ClaredonStyle,
  MicrobrewSoftFourStyle,
  HumbleCraftman,
  Poppins
};
